<template>
  <div class="like">
    <div class="top"></div>
    <van-nav-bar
      title="我的收藏"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="back"
    />
    <div class="my-bg">
      <div
        class="bg"
        :style="{backgroundImage: `url(${bg})`}"
      ></div>
    </div>

    <div class="like-box">

      <div
        class="product-box clearfix"
        v-if="likeData.length > 0"
      >
        <div
          class="product-item fl"
          :class="[index % 2 == 0 ? 'p-left' : 'p-right']"
          v-for="(item,index) in likeData"
          :key="index"
        >
          <div class="p-img">
            <img
              class="auto-img"
              :src="item.smallImg"
              alt=""
              @click="viewProductInfo(item.pid)"
            >
          </div>
          <div class="clearfix">
            <div class="pro-name one-text fl">{{item.name}}</div>
            <div
              class="pro-remove fr"
              @click="removeLike(item.pid,index)"
            >
              <van-icon
                name="delete"
                color="#999"
                size="20"
              ></van-icon>
            </div>
          </div>
          <div class="clearfix">
            <div class="en-pro-name one-text fl">{{item.enname}}</div>
            <div class="pro-price fl">{{item.price}}</div>
          </div>
        </div>

      </div>

      <div
        v-else
        class="empty-box"
      >
        <van-empty
          description="没有收藏商品,去逛一逛！"
          image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        >
          <van-button
            round
            type="info"
            class="bottom-button"
            @click="goMenu"
          >
            逛一逛
          </van-button>
        </van-empty>
      </div>

    </div>
  </div>
</template>

<script>
import "../assets/less/like.less";
import { utils } from "../assets/js/Utils";
export default {
  data() {
    return {
      // 我的收藏商品数据
      likeData: [],
      bg: "",
    };
  },
  created() {
    // 获取我的收藏商品数据
    this.getAllLikeData();

    // 获取用户背景图
    this.getBg();
  },
  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    },

    // 获取用户背景图片
    getBg() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.axios({
        method: "GET",
        url: "/findMy",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == "A001") {
            this.bg = result.data.result[0].userBg;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 获取我的收藏商品数据
    getAllLikeData() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return this.$router.push({ name: "Login" });
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/findAllLike",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 2000) {
            this.likeData = result.data.result;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 查看商品详情
    viewProductInfo(pid) {
      this.$router.push({ name: "Detail", query: { pid } });
    },

    // 删除收藏商品
    removeLike(pid, index) {
      // pid:商品id
      // index: 下标

      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return this.$router.push({ name: "Login" });
      }

      // 参数序列化
      let data = utils.queryString({
        appkey: this.appkey,
        tokenString,
        pid,
      });

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "POST",
        url: "/notlike",
        data,
      })
        .then((result) => {
          this.$toast.clear();
          if (result.data.code == 700) {
            return this.$router.push({ name: "Login" });
          }
          if (result.data.code == 900) {
            this.likeData.splice(index, 1);
            this.$toast("删除收藏商品成功");
          } else {
            this.$toast("删除收藏商品失败");
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 去逛一逛
    goMenu() {
      return this.$router.push({ name: "Menu" });
    },
  },
};
</script>
